import React from "react";
import ForgotPasswordAppLayer from "../components/ForgotPasswordAppLayer";

const ForgotPasswordAppPage = () => {
  return (
    <>
      <ForgotPasswordAppLayer />
    </>
  );
};

export default ForgotPasswordAppPage;
